<div class="h-full flex flex-col">
  <div class="flex flex-col grow w-full gap-3">
    <div>
      <pre>{{ transactionDisplay }}</pre>
    </div>

    <div class="flex grow">
      <div class="w-3/4">
        <span class="font-italic">{{ message }}</span>
      </div>
    </div>

    <div class="flex mb-4">
      <button
        (click)="close()"
        pButton
        type="button"
        icon="pi pi-times"
        label="Close"
        class="p-button-raised"
      ></button>
    </div>
  </div>
</div>
